module.exports = __webpack_public_path__ + "img/Logo.b602ab1b.png";